export default __webpack_public_path__ + "static/lockers-dd069fb3bc295aa22ff83adaf3b59a1f.gif";